define("SDB.SDBLocations.QuoteMessage.View", [
  "sdb_quote_message.tpl",
  "SCView",
  "SDB.SDBLocations.Model",
], function (sdb_quote_message_tpl, SCViewComponent, SDBLocationModel) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBQuoteMessage(options) {
    SCView.call(this);
    this.env = options.container.getComponent("Environment");

    this.options = options;
    this.model = SDBLocationModel.getInstance();
    this.template = sdb_quote_message_tpl;

    this.getDays();
    this.updateMessage();

    var self = this;
    this.model.on(
      "change:location",
      function () {
        if (self.model.getShoppingExperience() === "online") return;
        self.updateMessage();
        self.render();
      },
      this
    );

    this.model.on(
      "change:shoppingExperience",
      function () {
        if (self.model.getShoppingExperience() !== "online") return;
        self.updateMessage();
        self.render();
      },
      this
    );
  }

  SDBQuoteMessage.prototype = Object.create(SCView.prototype);
  SDBQuoteMessage.prototype.constructor = SDBQuoteMessage;

  SDBQuoteMessage.prototype.formatPhoneNumber = function formatPhoneNumber(
    phoneNumber
  ) {
    var regex = /\+1(\d{3})(\d{3})(\d{4})/;
    var match = phoneNumber.match(regex);
    if (match) {
      return {
        formatted: "(" + match[1] + ") " + match[2] + "-" + match[3],
        raw: "+1-" + match[1] + "-" + match[2] + "-" + match[3],
      };
    }
  };

  SDBQuoteMessage.prototype.getDays = function getDays() {
    var message = this.env.getConfig("quote.requestAQuoteWizardBottomMessage");
    var regex = /<strong>(\d+) business days<\/strong>/;
    var match = message.match(regex);
    this.days = match
      ? match[1] + " business days"
      : "the next couple of hours";
  };

  SDBQuoteMessage.prototype.updateMessage = function updateMessage() {
    if (
      this.model.getShoppingExperience() === "online" ||
      !this.model.getSelectedLocation()
    ) {
      this.message = this.env.getConfig(
        "quote.requestAQuoteWizardBottomMessage"
      );
      return;
    }
    var subsidiaryInformation = this.model.getSelectedLocation();
    var salesrepEmail = subsidiaryInformation.email;
    if (!subsidiaryInformation.phone) {
      var days = this.days;
      this.message =
        "Once your quote has been submitted, a sales representative will contact you in <strong>" +
        days +
        '</strong>. For immediate assistance email us at <a href="mailto:' +
        salesrepEmail +
        '">' +
        salesrepEmail +
        "</a>";
      return;
    }
    var phoneParts = this.formatPhoneNumber(subsidiaryInformation.phone);
    var days = this.days;
    this.message =
      "Once your quote has been submitted, a sales representative will contact you in <strong>" +
      days +
      "</strong>. For immediate assistance call us at <strong>" +
      phoneParts.formatted +
      '</strong> or email us at <a href="mailto:' +
      salesrepEmail +
      '">' +
      salesrepEmail +
      "</a>";
  };

  SDBQuoteMessage.prototype.getContext = function () {
    return {
      message: this.message,
    };
  };

  return SDBQuoteMessage;
});
